webpackJsonp([235188726511790],{

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionApp = __webpack_require__(286);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionApp).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	__webpack_require__(447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionApp = function SectionApp(_ref) {
	  var gray = _ref.gray,
	      data = _ref.data;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'Next Miss app',
	      subtitle: 'One platform for all beauty pageants',
	      gray: gray
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'mw792 center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex mb4' },
	        _react2.default.createElement(Item, { imgSrc: data.nextMissApp1.sizes }),
	        _react2.default.createElement(Item, { imgSrc: data.nextMissApp2.sizes }),
	        _react2.default.createElement(Item, { imgSrc: data.nextMissApp3.sizes }),
	        _react2.default.createElement(Item, { imgSrc: data.nextMissApp4.sizes })
	      ),
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'Get your beauty pageant listed on Next Miss Media and get new visibility and revenue. Our team will help you to get started.'
	      )
	    )
	  );
	};
	
	function Item(_ref2) {
	  var imgSrc = _ref2.imgSrc;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'w-25' },
	    _react2.default.createElement(_gatsbyImage2.default, { sizes: imgSrc, alt: '' })
	  );
	}
	
	exports.default = SectionApp;
	module.exports = exports['default'];

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionCoreOffering = __webpack_require__(306);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionCoreOffering).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	__webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionCoreOffering = function SectionCoreOffering(_ref) {
	  var gray = _ref.gray,
	      data = _ref.data;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'Our core offering',
	      subtitle: 'The revolutionary Next Miss app',
	      gray: gray,
	      className: 'overflow-hidden'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex flex-wrap mb5 mb6-m mb7-l' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-grow-1 mw197 mr3 mr5-m mr6-l ml--100-sm' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.coreOffering1.sizes, alt: '' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-grow-1 flex-basis-0' },
	        _react2.default.createElement(
	          _largeText2.default,
	          { align: 'left' },
	          'This has never been more important in a world where the speed of digital transformation is disrupting entire industries and changing competitive landscapes. ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'We have developed a designated app for beauty pageant community. The new app\u2019s purpose is to become the main digital media for beauty pageant fans around the world.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-grow-1 flex-basis-0' },
	        _react2.default.createElement(
	          _largeText2.default,
	          { align: 'right' },
	          'In Next Miss app you can find a complete set of tools to run your beauty pageant digitally. On top of this, we consult, collaborate, challenge and create, to deliver great results for you. ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Below, we introduce you our three core offerings of New Digital Tools, New Revenue Streams and Digital Experience and build on the premise that good is never good enough.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-grow-1 mw197 ml3 ml5-m ml6-l mr--100-sm' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.coreOffering2.sizes, alt: '' })
	      )
	    )
	  );
	};
	
	exports.default = SectionCoreOffering;
	module.exports = exports['default'];

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionDigitalExperience = __webpack_require__(310);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionDigitalExperience).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	__webpack_require__(457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionDigitalExperience = function SectionDigitalExperience(_ref) {
	  var gray = _ref.gray,
	      data = _ref.data;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    { title: 'Digital Experience', gray: gray },
	    _react2.default.createElement(
	      'div',
	      { className: 'mw800 center' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.digitalExperience.sizes, className: 'mb4 mw690 center', alt: '' }),
	      _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'Every business is becoming a digital business. This applies to beauty pageant organisations as well. Today audiences have high expectations of what they want from their beauty pageants. This is where Next Miss can help your organisation with ready made turnkey solutions.'
	        ),
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'Next Miss supports beauty pageant organisations by providing them with best in class digital solutions to all improve their offering to audiences. Our award-winning solutions are user experience obsessed and have direct impact on revenue generation, audience experience and overall business performance.'
	        ),
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'It all may sound too technical. But worry not, our digital tools can be installed to your digital environment in minutes. No digital expertise is needed, we take care of everything for you. Contact us to learn more.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SectionDigitalExperience;
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionDigitalTools = __webpack_require__(312);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionDigitalTools).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionDigitalTools = function SectionDigitalTools(_ref) {
	  var gray = _ref.gray,
	      data = _ref.data;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    { title: 'New Digital Tools', gray: gray },
	    _react2.default.createElement(
	      'div',
	      { className: 'mw800 center' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.digitalTools.sizes, className: 'mb6', alt: '' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'tc' },
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'At Next Miss, we focus always to deliver the best possible digital tools for you. All our digital tool are packaged in a format that is easy and fast to start to use. Together as partners we always decide together which tools are suitable for you.'
	        ),
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'We have used years and thousands of long hours to develop the best and most easy to use digital toolkit ever available exclusively to our beauty pageant partners. We pride ourselves about this achievement \u2013 and the results speak louder than words.'
	        ),
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'No hassle, no waiting. everything is ready now. Shall you need an online casting tool, most advanced online voting or judge rating tool, we have solutions available for all these categories.'
	        ),
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'As we have experience of helping hundreds of beauty pageants, we can give recommendations which tools to use in your case. Let\u2019s talk, so you can here more about our digital tools.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SectionDigitalTools;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionRevenue = __webpack_require__(101);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionRevenue).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _icons = __webpack_require__(11);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	__webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionRevenueImg = function SectionRevenueImg(_ref) {
	  var sizes = _ref.sizes,
	      icon = _ref.icon,
	      iconText = _ref.iconText,
	      number = _ref.number,
	      numberText = _ref.numberText;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'w-100 w-50-m w-25-l ph3 mb4 mb0-l' },
	    _react2.default.createElement(
	      'div',
	      { className: 'mw186 center' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes, alt: '', className: 'mb4' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mb2 pa2 w96 min-h96 ba b--moon-gray br2 center flex flex-column items-center justify-center' },
	        _react2.default.createElement(_icons2.default, { icon: icon, size: '36px', className: 'mb2' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'mv0 f13 tc' },
	          iconText
	        )
	      ),
	      !!number && _react2.default.createElement(
	        'div',
	        { className: 'flex' },
	        _react2.default.createElement(
	          'div',
	          { className: 'mr2 flex-shrink-0 w50 h50 bg-black white pa2 br-100 flex items-center justify-center' },
	          number
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'mv0 f13 mv1' },
	          numberText
	        )
	      )
	    )
	  );
	};
	
	SectionRevenueImg.propTypes = {
	  sizes: _propTypes2.default.object
	};
	
	exports.default = SectionRevenueImg;
	module.exports = exports['default'];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _businessSection = __webpack_require__(10);
	
	var _businessSection2 = _interopRequireDefault(_businessSection);
	
	var _icons = __webpack_require__(11);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	var _sectionRevenueImg = __webpack_require__(100);
	
	var _sectionRevenueImg2 = _interopRequireDefault(_sectionRevenueImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionRevenue = function SectionRevenue(_ref) {
	  var data = _ref.data,
	      gray = _ref.gray,
	      isSimple = _ref.isSimple;
	
	  return _react2.default.createElement(
	    _businessSection2.default,
	    {
	      title: 'New Revenue Streams',
	      subtitle: isSimple ? '' : 'Let consumers buy extra votes & bring sponsors to your votes',
	      topGreen: true,
	      gray: gray
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex flex-wrap justify-center mh--3 mb4' },
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg1.sizes,
	        icon: 'three-stars',
	        iconText: 'Paid votes',
	        number: isSimple ? '' : _react2.default.createElement(_icons2.default, { icon: 'starFilled', size: '60%' }),
	        numberText: 'Let your audience buy extra vote packages and share your contest'
	      }),
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg2.sizes,
	        icon: 'batman',
	        iconText: 'Branded Buttons',
	        number: isSimple ? '' : _react2.default.createElement(
	          'span',
	          { className: 'f4 fw5' },
	          '1'
	        ),
	        numberText: 'Brand the voting button let your audience vote by touching your brand'
	      }),
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg3.sizes,
	        icon: 'play-circle',
	        iconText: 'Video ads',
	        number: isSimple ? '' : _react2.default.createElement(
	          'span',
	          { className: 'f4 fw5' },
	          '2'
	        ),
	        numberText: 'Then your audience will automatically see a 15sec commercial'
	      }),
	      _react2.default.createElement(_sectionRevenueImg2.default, {
	        sizes: data.revenueImg4.sizes,
	        icon: 'lead-capture',
	        iconText: 'Lead Capture',
	        number: isSimple ? '' : _react2.default.createElement(
	          'span',
	          { className: 'f4 fw5' },
	          '3'
	        ),
	        numberText: 'While watching the commercial they can fill their contact info to get discounts, win prizes or participate in campaigns'
	      })
	    ),
	    isSimple && _react2.default.createElement(
	      'div',
	      { className: 'mw800 center' },
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'Due to our experience and expertise in the beauty pageant industry, we are specialized in helping our clients with creating new digital revenue streams for their businesses.'
	      ),
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'As we all know, many beauty pageants have large audiences but have yet been unsuccessful to monetize their audience. We have helped hundreds of organisers to successfully create new revenue for their businesses from scratch.'
	      ),
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'Our tailormade turnkey solutions like paid votes, video ads, lead capture and branded buttons help your organisation to generate totally new revenue for you.'
	      ),
	      _react2.default.createElement(
	        _largeText2.default,
	        null,
	        'To get access to our readymade toolkit is easy. Just contact us and we can set up tailored made solutions according to your needs. All features can be live in your digital environment in hours after we have agreed together the best solution for your beauty pageant.'
	      )
	    )
	  );
	};
	
	SectionRevenue.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = SectionRevenue;
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sectionWhatWeDo = __webpack_require__(337);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sectionWhatWeDo).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _mainSectionLayout = __webpack_require__(29);
	
	var _mainSectionLayout2 = _interopRequireDefault(_mainSectionLayout);
	
	var _getStartedButton = __webpack_require__(56);
	
	var _getStartedButton2 = _interopRequireDefault(_getStartedButton);
	
	var _pageTopBar = __webpack_require__(30);
	
	var _pageTopBar2 = _interopRequireDefault(_pageTopBar);
	
	var _largeText = __webpack_require__(13);
	
	var _largeText2 = _interopRequireDefault(_largeText);
	
	__webpack_require__(468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionWhatWeDo = function SectionWhatWeDo(_ref) {
	  var gray = _ref.gray,
	      data = _ref.data;
	
	  return _react2.default.createElement(
	    _pageTopBar2.default,
	    { iconName: 'laptop', text: 'What we do' },
	    _react2.default.createElement(
	      _mainSectionLayout2.default,
	      {
	        noLogo: true,
	        title: 'What we do',
	        about: 'We bring beauty pageants to the next level with cutting-edge digital tools'
	      },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.whatWeDoMain.sizes, alt: '', className: 'db mw500 center mb6' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mw800 center mb6' },
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'The Next Miss app provides the perfect environment for beauty fans to enjoy your content.'
	        ),
	        _react2.default.createElement(
	          _largeText2.default,
	          null,
	          'We help our clients to be highly effective in running their beauty pageants; ',
	          _react2.default.createElement('br', null),
	          'to embrace change with confidence; and to support them engage more with their audience, ready to take on the next challenge.'
	        )
	      ),
	      _react2.default.createElement(_getStartedButton2.default, null)
	    )
	  );
	};
	
	exports.default = SectionWhatWeDo;
	module.exports = exports['default'];

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/what_we_do.4b8a0106.png";

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _sectionWhatWeDo = __webpack_require__(336);
	
	var _sectionWhatWeDo2 = _interopRequireDefault(_sectionWhatWeDo);
	
	var _sectionCoreOffering = __webpack_require__(305);
	
	var _sectionCoreOffering2 = _interopRequireDefault(_sectionCoreOffering);
	
	var _sectionDigitalTools = __webpack_require__(311);
	
	var _sectionDigitalTools2 = _interopRequireDefault(_sectionDigitalTools);
	
	var _sectionApp = __webpack_require__(285);
	
	var _sectionApp2 = _interopRequireDefault(_sectionApp);
	
	var _sectionDigitalExperience = __webpack_require__(309);
	
	var _sectionDigitalExperience2 = _interopRequireDefault(_sectionDigitalExperience);
	
	var _sectionRevenue = __webpack_require__(99);
	
	var _sectionRevenue2 = _interopRequireDefault(_sectionRevenue);
	
	var _what_we_do = __webpack_require__(660);
	
	var _what_we_do2 = _interopRequireDefault(_what_we_do);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = function (_Component) {
	  _inherits(Homepage, _Component);
	
	  function Homepage() {
	    _classCallCheck(this, Homepage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Homepage.prototype.render = function render() {
	    var data = this.props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'What we do'
	        ),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'What we do' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'We bring beauty pageants to the next level with cutting-edge digital tools' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://nextmiss.com' + _what_we_do2.default }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://nextmiss.com/what_we_do/' }),
	        _react2.default.createElement('meta', { property: 'og:image:alt', content: 'What we do - Next Miss' })
	      ),
	      _react2.default.createElement(_sectionWhatWeDo2.default, { data: data }),
	      _react2.default.createElement(_sectionCoreOffering2.default, { data: data, gray: true }),
	      _react2.default.createElement(_sectionApp2.default, { data: data }),
	      _react2.default.createElement(_sectionDigitalTools2.default, { data: data, gray: true }),
	      _react2.default.createElement(_sectionDigitalExperience2.default, { data: data }),
	      _react2.default.createElement(_sectionRevenue2.default, { data: data, gray: true, isSimple: true })
	    );
	  };
	
	  return Homepage;
	}(_react.Component);
	
	exports.default = Homepage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-what-we-do-js-5e1c88f54de46c9e66a1.js